import { NgModule }            from '@angular/core';
import { CommonModule }        from '@angular/common';
import { HttpModule }          from '@angular/http';
import { FormsModule, ReactiveFormsModule, }         from '@angular/forms';
import { CampaignListComponent } from '../components/campaign-list.component';
import { MomentPipe } from '../pipes/moment';
import { SafeHtmlPipe } from '../pipes/safehtml';
import { TextPipe } from '../pipes/text';
import { PaymentsComponent } from '../payments/payment'
import { MerchListComponent } from '../merchlist/merchlist';

import { TextMaskModule } from 'angular2-text-mask';
import { DragDropModule } from 'primeng/primeng';
import { CalendarModule } from 'primeng/primeng';
import { FileUploadModule } from 'primeng/primeng';
import { EditorModule } from 'primeng/primeng';
import { DropdownModule } from 'primeng/primeng';
import { GrowlModule } from 'primeng/primeng';
import { MetaComponent } from '../components/meta.component';
import { ChartModule } from 'primeng/primeng';

@NgModule({
  imports:      [ CommonModule,
                  HttpModule,
                  FormsModule,
                  ReactiveFormsModule,
                  TextMaskModule,
                  GrowlModule,
                  DragDropModule,
                  CalendarModule,
                  FileUploadModule,
                  EditorModule,
                  DropdownModule,
                  ChartModule
                ],
  declarations: [ CampaignListComponent,
                  PaymentsComponent,
                  MomentPipe,
                  SafeHtmlPipe,
                  TextPipe,
                  MerchListComponent,
                  MetaComponent
                ],
  exports:      [ CampaignListComponent,
                  CommonModule,
                  HttpModule,
                  FormsModule,
                  ReactiveFormsModule,
                  TextMaskModule,
                  PaymentsComponent,
                  MomentPipe,
                  SafeHtmlPipe,
                  TextPipe,
                  MerchListComponent,
                  GrowlModule,
                  DragDropModule,
                  CalendarModule,
                  FileUploadModule,
                  EditorModule,
                  DropdownModule,
                  MetaComponent,
                  ChartModule
                ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/shared/shared.module.ts